export const BOOKING_DATA_CHANGE = 'booking/DATA_CHANGE';

export const setBookingData = (payload) => ({
  type: BOOKING_DATA_CHANGE,
  payload,
});
